import {create} from 'fedops-logger';

const fedopsLogger = create('engage-chat');

export default fedopsLogger;



// WEBPACK FOOTER //
// ./chat-app/services/fedopsLogger.js